<template>
  <transition name="slide-fade">
    <div class="d-flex">
      <router-link class="d-flex w-100" :to="{ name: 'scenario-view', params: { uuidId: uuidId } }">
        <div class="d-flex justify-content- relative w-75">
          <div class="text-center rounded d-flex align-items-center">
            <img :src="deviceThumb" title style="width:65px;" />
          </div>
          <div class="ml-4 d-flex flex-column text-left">
            <h6 class="text-left">{{ name }}</h6>
            <div class="d-flex justify-content-start">
              <i class="material-icons text-secondary mr-2">person</i>
              <span class="d-block element-label">{{contributedBy}}</span>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-end w-25">
          <i
            class="remove-button material-icons"
            @click.prevent="toggleFavourited"
            style="display:flex; align-items:center"
          >remove_circle</i>
        </div>
      </router-link>
    </div>
  </transition>
</template>

<script>
import Scenario from "./Scenario";
import scenService from "../services/scenarios.service";
export default {
  name: "FavouriteScenario",
  extends: Scenario,
  props: {
    uuidId: String
  },
  methods: {
    toggleFavourited() {
      scenService.toggleFavouriteScenario(this.uuidId).then(data => {
        this.favouritedByUser = data.toggled === "true";
        this.$parent.updateFavouriteScenariosList();
      });
    }
  }
};
</script>

<style scoped>
img {
  width: 20%;
  height: auto;
}

.remove-button {
  cursor: pointer;
  font-size: 25px;
  color: #dc3545;
  background: none;
  z-index: 5;
}
</style>
